import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { format } from 'date-fns'

import { DEFAULT_FEE_ATTACHMENT_BODY } from 'citadel-shared/variables.js'

import { replaceConfigVariables } from '../../util/variableFormatting'
import { FlexColumn, FlexRow, SpaceBetweenRowContainer } from '../styles/Containers'
import { BoldFormTitle, MedBodyText, BoldMedBodyText } from '../styles/Text'
import RichTextReadOnly from '../inputFields/RichTextReadOnly'

const LastModifiedRow = styled(FlexRow)`
  flex-wrap: wrap;
`

function formatDateParts(date) {
  return {
    datePart: format(date, 'MMM-dd-yyyy'),
    timePart: format(date, 'hh:mm a')
  }
}

function CommunicationTemplateReadOnly({ template, publicConfig = {} }) {
  const { name, body, updatedAt } = template

  const dateParts = formatDateParts(updatedAt)
  const normalizedFeeAttachmentBody = replaceConfigVariables({ html: DEFAULT_FEE_ATTACHMENT_BODY, publicConfig })

  return (
    <FlexColumn gap="20px">
      <SpaceBetweenRowContainer gap="5px 15px">
        <BoldFormTitle>{name}</BoldFormTitle>
        <LastModifiedRow gap="5px">
          <BoldMedBodyText>Last Modified: {dateParts.datePart}</BoldMedBodyText>
          <MedBodyText>{dateParts.timePart}</MedBodyText>
        </LastModifiedRow>
      </SpaceBetweenRowContainer>
      <RichTextReadOnly value={body} />
      <FlexColumn gap="10px">
        <MedBodyText>The following text will be automatically included in your communication when a fee is attached:</MedBodyText>
        <RichTextReadOnly value={normalizedFeeAttachmentBody} />
      </FlexColumn>
    </FlexColumn>
  )
}

CommunicationTemplateReadOnly.propTypes = {
  template: PropTypes.shape({
    name: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    updatedAt: PropTypes.instanceOf(Date).isRequired
  }).isRequired,
  publicConfig: PropTypes.object
}

export default CommunicationTemplateReadOnly
